import React, { useState, useEffect } from "react";
import { Table, Button, Tag, Input, Pagination, Card, message, Popconfirm } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../../api";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";

const CustomerIndexPage = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  // Fetch customers from API
  const fetchCustomers = async (page = 1, pageSize = 10, search = "") => {
    setLoading(true);
    try {
      const response = await api.get("/panel/call-center-request", {
        params: { page, per_page: pageSize, search },
      });
      
      setCustomers(response.data.data);
      setFilteredCustomers(response.data.data);
      setPagination({
        current: response.data.meta.current_page,
        pageSize: response.data.meta.per_page,
        total: response.data.meta.total,
      });
    } catch (error) {
      console.error("Error fetching customers:", error);
      message.error("خطا در دریافت اطلاعات مشتریان");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/panel/call-center-request/${id}`);
      message.success("آیتم مورد نظر با موفقیت حذف شد");
      fetchCustomers(pagination.current, pagination.pageSize, searchQuery);
    } catch (error) {
      console.error("خطا در حذف آیتم:", error);
      message.error("خطا در حذف آیتم");
    }
  }; 

  useEffect(() => {
    fetchCustomers(pagination.current, pagination.pageSize, searchQuery);
  }, [pagination.current, pagination.pageSize, searchQuery]);

  // Handle search input change
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle pagination change
  const handlePaginationChange = (page, pageSize) => {
    setPagination({ ...pagination, current: page, pageSize });
  };

  // Columns for the table
  const columns = [
    {
      title: "نام و نام خانوادگی",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "شماره تلفن",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "شماره شاسی",
      dataIndex: "chassis_number",
      key: "chassis_number",
    },
    // {
    //   title: "آدرس",
    //   dataIndex: "address",
    //   key: "address",
    //   ellipsis: true,
    // },
    {
      title: "برند خودرو",
      dataIndex: "car_brand",
      key: "car_brand",
    },
    {
      title: "مدل خودرو",
      dataIndex: "car_model",
      key: "car_model",
    },
    {
      title: "نام قطعه",
      dataIndex: "part_name",
      key: "part_name",
    },
    {
      title: "قیمت (تومان)",
      dataIndex: "price",
      key: "price",
      render: (price) => price ? parseInt(price).toLocaleString() : "-",
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "green";
        let text = status;
        
        if (status === "pending") {
          color = "red";
          text = "در انتظار";
        } else if (status === "priced") {
          color = "gold";
          text = "قیمت‌گذاری شده";
        }else if (status === "completed") {
          color = "green";
          text = " تکمیل شده";
        }
        
        return <Tag color={color}>{text}</Tag>;
      }
    },
    {
      title: "منجر به فروش",
      dataIndex: "has_bought",
      key: "has_bought",
      render: (has_bought) => (
        <Tag color={has_bought === 1 ? "green" : "red"}>
          {has_bought === 1 ? "بله" : "خیر"}
        </Tag>
      ),
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "عملیات",
      key: "actions",
      render: (text, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            onClick={() => navigate(`/call_center/edit/${record.id}`)}
            icon={<EditOutlined />}
          />
          <Popconfirm
            title="آیا از حذف اطلاعات این مشتری مطمئن هستید؟"
            onConfirm={() => handleDelete(record.id)}
            okText="بله"
            cancelText="خیر"
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Card>
      <div className="mb-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold">ثبت اطلاعات مشتری</h1>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/call_center/add")}
        >
          افزودن درخواست جدید
        </Button>
      </div>
      <div className="mb-4">
        <Input
          allowClear
          placeholder="جستجو بر اساس نام، شماره تلفن، برند خودرو یا نام قطعه"
          value={searchQuery}
          onChange={handleSearch}
          style={{ width: 300 }}
        />
      </div>
      
      <Table
        dataSource={filteredCustomers}
        columns={columns}
        loading={loading}
        rowKey="id"
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
      <Pagination
        current={pagination.current}
        pageSize={pagination.pageSize}
        total={pagination.total}
        onChange={handlePaginationChange}
        style={{ marginTop: 16, textAlign: "center" }}
        showSizeChanger
        showTotal={(total) => `مجموع ${total} مورد`}
      />
    </Card>
  );
};

export default CustomerIndexPage;